import { apiCaller } from '../ApiCaller/ApiCaller';

export async function createCaseDataOfContact(caseData) {

    const createCaseData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/createCaseDetail", caseData);
      return createCaseData;
}